<template>
  <div>
    <el-row class="form-row" v-for="(row, ri) in formConfig" :key="ri">
      <el-col
        v-for="(item, ii) in row.data"
        :xl="item.xl ? item.xl : 6"
        :md="item.grid ? item.grid : 8"
        :sm="item.sm ? item.sm : 12"
        :xs="item.xs ? item.xs : 24"
        :key="ii"
      >
        <el-form-item
          :label="item.label"
          :prop="item.rule"
          :class="item.className"
          v-permission="item.permission"
        >
          <template v-if="item.type === 'INPUT'">
            <el-input
              v-model="form[item.model]"
              v-bind="item.props"
              :disabled="item.disabled"
              :placeholder="item.placeholder"
            >
              <template v-if="item.slot">
                <template v-if="item.slot.prepend">
                  <span slot="prepend">{{ item.slot.prepend.text }}</span>
                </template>
                <template v-if="item.slot.append">
                  <span slot="append">{{ item.slot.append.text }}</span>
                </template>
              </template>
            </el-input>
          </template>
          <template v-if="item.type === 'DATE'">
            <el-date-picker
              v-model="form[item.model]"
              v-bind="item.props"
              type="datetime"
              placeholder="请选择时间1"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
              :disabled="item.disabled"
              :readonly="item.disabled"
            ></el-date-picker>
          </template>
          <template v-if="item.type === 'DATETIME_RRANGE'">
            <el-date-picker
              v-model="form[item.model]"
              v-bind="item.props"
              type="datetimerange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 96%"
              :disabled="item.disabled"
              :readonly="item.disabled"
            ></el-date-picker>
          </template>
          <template v-if="item.type === 'DATE_RANGE'">
            <el-date-picker
              v-model="form[item.model]"
              v-bind="item.props"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 96%"
              :disabled="item.disabled"
              :readonly="item.disabled"
            ></el-date-picker>
          </template>
          <template v-if="item.type === 'CONTRAST_INPUT'">
            <el-select
              v-model="form[item.props.operator]"
              v-bind="item.props"
              :disabled="item.disabled"
              filterable
              style="width: 120px"
            >
              <el-option
                v-for="(brand, bi) in item.props.data"
                :value="brand.value"
                :key="bi"
                :label="brand.label"
                >{{ brand.label }}</el-option
              >
            </el-select>
            <el-input
              v-model="form[item.model]"
              v-bind="item.props"
              :disabled="item.disabled"
              style="width: 77%"
            ></el-input>
          </template>
          <template v-if="item.type === 'CONTRAST_DATETIME_RRANGE'">
            <el-select
              v-model="form[item.props.operator]"
              v-bind="item.props"
              :disabled="item.disabled"
              filterable
              style="width: 30%"
            >
              <el-option
                v-for="(brand, bi) in item.props.data"
                :value="brand.value"
                :key="bi"
                :label="brand.label"
                >{{ brand.label }}</el-option
              >
            </el-select>
            <el-date-picker
              v-model="form[item.model]"
              v-bind="item.props"
              type="datetimerange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 70%"
              :disabled="item.disabled"
              :readonly="item.disabled"
            ></el-date-picker>
          </template>
          <template v-if="item.type === 'INPUT_NUMBER'">
            <el-input-number
              v-model="form[item.model]"
              v-bind="item.props"
              :disabled="item.disabled"
            ></el-input-number>
            <span v-if="item.unit">{{ item.unit }}</span>
          </template>
          <template v-if="item.type === 'TEXTAREA'">
            <el-input
              v-model="form[item.model]"
              type="textarea"
              v-bind="item.props"
              :disabled="item.disabled"
            />
          </template>
          <template v-if="item.type === 'CASCADER'">
            <el-cascader
              v-bind="item.props"
              :options="item.props.data"
              v-model="form[item.model]"
              :change-on-select="item.props.changeOnSelect"
              :disabled="item.disabled"
              filterable
              clearable
            ></el-cascader>
          </template>
          <template v-if="item.type === 'SELECT'">
            <el-select
              v-model="form[item.model]"
              v-bind="item.props"
              :disabled="item.disabled"
              :placeholder="item.placeholder"
              filterable
              clearable
              :multiple="item.multiple"
              @change="handleChange($event, item)"
            >
              <el-option
                v-for="(brand, bi) in item.props.data"
                :value="brand.value"
                :key="bi"
                :label="brand.label"
                >{{ brand.label }}</el-option
              >
            </el-select>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "CustomizeForm",
  props: {
    formConfig: Array,
    form: Object,
  },
  methods: {
    handleChange(val, item) {
      if (
        item.props.hasOwnProperty("onChange") &&
        typeof item.props.onChange == "function"
      ) {
        return item.props.onChange(val);
      } else {
        return () => {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  .contrast_input {
    width: 40%;
    margin-left: 10px;
  }
}
</style>
